// const getTranslationFor = ({ msgid, defaultLabel }) => {
//   return getTranslationCatalog().then(catalog => {
//     if (!catalog) {
//       return '';
//     }
//     const { data } = catalog;
//     return data[msgid] ? data[msgid] : defaultLabel;
//   });
// };
export const getTranslationCatalog = (domain = "unife.policy") => {
  const catalogUrl = document
    .querySelector("body")
    .getAttribute("data-i18ncatalogurl");

  if (!catalogUrl) {
    return Promise.resolve(null);
  }

  let language = document.querySelector("html").getAttribute("lang");
  if (!language) {
    language = "en";
  }

  const params = new URLSearchParams({ domain, language });

  return fetch(`${catalogUrl}?${params.toString()}`, {
    method: "GET",
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      return { ...data, language };
    })
    .catch((error) => {
      console.error("Error fetching translation catalog:", error);
      return null;
    });
};
